module.exports = __webpack_public_path__ + "img/search_report.0a90479b.png";